import { render, staticRenderFns } from "./AnswerBox.vue?vue&type=template&id=6d113919&scoped=true"
import script from "./AnswerBox.vue?vue&type=script&lang=js"
export * from "./AnswerBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d113919",
  null
  
)

export default component.exports